export default __webpack_public_path__ + "static/media/pagofacil.74396c98.png";